import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

import { getLanguage } from "../../../utils/getLanguage";
import Button from "../../Button";
import Modal from "../../Modal";

const PreviewImportedStudentModal = forwardRef(({}, ref) => {
  const lang = getLanguage();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useImperativeHandle(ref, () => ({
    openModal(receivedData) {
      setData(receivedData.data);
      setCurrentIndex(receivedData.index); // Set the clicked row index
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleNext = () => {
    if (currentIndex < data.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      header={
        <div className="font-light">
          {t("classroom_name")}: <span className="text-lg font-semibold">{data[currentIndex]?.name}</span>
        </div>
      }
      footer={
        <div className="flex w-full justify-between">
          <Button
            variant="text"
            label={t("previous")}
            iconLeft={<MdChevronLeft size={20} className={lang == "ar" && "rotate-180"} />}
            onClick={handlePrev}
            disabled={currentIndex === 0}
          />

          <Button
            variant="text"
            label={t("next")}
            iconRight={<MdChevronRight size={20} className={lang == "ar" && "rotate-180"} />}
            onClick={handleNext}
            disabled={currentIndex === data.length - 1}
          />
        </div>
      }
    >
      <div className="flex flex-col items-center gap-6">
        {data[currentIndex]?.students?.length > 0 ? (
          <ul className="w-full max-w-md space-y-2">
            {data[currentIndex].students.map((student, index) => (
              <li key={index} className="flex items-center rounded-lg bg-gray-50 p-4 dark:bg-dark-background">
                <div className="flex flex-col">
                  <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{student}</p>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-300">{t("no_students_imported")}</p>
        )}
      </div>
    </Modal>
  );
});

export default PreviewImportedStudentModal;
